import React, { FC, useEffect } from "react";

import { Col, Container, Row } from "reactstrap";

import CustomerProfileDetail from "./CustomerProfileDetail";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  flutterMessageSelector,
  lastLocationSelector,
} from "../../shared/actions/LayoutMode.actions";
import { useNavigate } from "react-router-dom";

const CustomerProfilePage: FC = () => {
  document.title =
    "Müşteri Bilgisi | Bu ekranda müşteri bilgileri düzenlemesi yapabilirsiniz";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const navigate = useNavigate();

  const { location } = useRecoilValue(lastLocationSelector);
  // const [flutterMessage, setFlutterMessage] = useRecoilState(
  //   flutterMessageSelector
  // );

  // useEffect(() => {
  //   if (flutterMessage.startsWith("back")) {
  //     navigate(location);
  //   }

  //   // setFlutterMessage("");
  // }, [flutterMessage]);

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          <button
            type="button"
            title="Previous"
            aria-pressed="false"
            className="fc-prev-button btn btn-light-primary p-3"
            onClick={() => navigate(location)}
          >
            <span className="fa fa-chevron-left"></span> Geri
          </button>

          <Row>
            <Col xl={12}>
              <CustomerProfileDetail />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CustomerProfilePage;
